import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { authenticationService } from '../../services/auth.service';
import { UserRoleEnum } from '../../models/enums/UserRoleEnum';
import { normalizeAppPath } from '../../utils/slug';

interface ProtectedRouteProps {
  allowedRoles?: UserRoleEnum[];
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { isAuthenticated } = useAuth();
  const { allowedRoles } = props

  if (isAuthenticated) {
    const user = authenticationService.currentUserValue;

    if (!allowedRoles) {
      return <Navigate to="/nao-autorizado" replace />;
    }
  
    if (user && allowedRoles && !authenticationService.hasAnyRole(allowedRoles)) {
      if (!allowedRoles.includes(UserRoleEnum.ALWAYS_ALLOWED)) {
        return <Navigate to="/nao-autorizado" replace />
      }
    }
  }

  const redirectTo = encodeURIComponent(normalizeAppPath(window.location.pathname));

  return isAuthenticated ? <Outlet /> : <Navigate to={`/entrar?redirecionar=${redirectTo}`} />
};

export default ProtectedRoute;
